import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

export default function createElementWithClass(withClass, options = {}) {
  if (!options.defaultTag || typeof options.defaultTag !== 'string') {
    throw new Error(
      `createElementWithClass expected options.defaultTag: String, but get ${typeof options.defaultTag}`,
    );
  }

  function EnhancedElement({ renderWith = '', className = '', ...rest }) {
    return React.createElement(renderWith || options.defaultTag, {
      className: cx(withClass, className),
      ...rest,
    });
  }

  EnhancedElement.propTypes = {
    renderWith: PropTypes.string,
    className: PropTypes.string,
  };

  EnhancedElement.displayName = `createElementWithClass(${withClass})`;

  return EnhancedElement;
}
